import { HttpClient } from "@angular/common/http";
import { Injectable, inject, signal } from "@angular/core";
import { IUser } from "./users/user.interface";
import { firstValueFrom } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class MatidorAdminService {
  _httpClient = inject(HttpClient);

  user = signal<IUser | null>(null);
  isLoadingUser = signal(false);

  async setCurrentUser(user: IUser) {
    this.user.set(user);
  }

  async getCurrentUser() {
    try {
      this.isLoadingUser.set(true);

      const response = await firstValueFrom(this._httpClient.get<IUser>(`${environment.apiUrl}/api/users/current-user`));

      this.user.set(response);

      this.isLoadingUser.set(false);
    } catch (error) {
      this.isLoadingUser.set(false);
      throw error;
    }
  }
}
